import React from 'react';
import { useUIStore } from '../../../apps/bim-catastro/stores';
import './ModalManager.css';

const ModalManager: React.FC = () => {
  const { modals, closeModal } = useUIStore();

  const handleConfirm = (modal: any) => {
    if (modal.onConfirm) {
      // Recolectar datos del formulario si existe
      const formData = collectFormData(modal);
      modal.onConfirm(formData);
    }
    closeModal(modal.id);
  };

  // Función para recolectar datos del formulario
  const collectFormData = (modal: any) => {
    const formData: any = {};
    
    // Buscar todos los inputs dentro del modal
    const modalElement = document.querySelector(`[data-modal-id="${modal.id}"]`);
    if (!modalElement) return formData;
    
    const inputs = modalElement.querySelectorAll('input, select, textarea');
    inputs.forEach((input: any) => {
      if (input.name || input.id) {
        const fieldName = input.name || input.id;
        let value = input.value;
        
        // Convertir tipos según el tipo de input
        if (input.type === 'number') {
          value = value === '' ? null : parseFloat(value);
        } else if (input.type === 'checkbox') {
          value = input.checked;
        }
        
        formData[fieldName] = value;
      }
    });
    
    return formData;
  };

  const handleCancel = (modal: any) => {
    if (modal.onCancel) {
      modal.onCancel();
    }
    closeModal(modal.id);
  };

  const handleOverlayClick = (e: React.MouseEvent, modal: any) => {
    if (e.target === e.currentTarget) {
      closeModal(modal.id);
    }
  };

  return (
    <>
      {modals.map((modal) => (
        modal.isOpen && (
          <div
            key={modal.id}
            className="v2-modal-overlay"
            onClick={(e) => handleOverlayClick(e, modal)}
          >
            <div className={`v2-modal ${modal.size || 'medium'}`} data-modal-id={modal.id}>
              {/* Header */}
              <div className="v2-modal-header">
                <h3 className="v2-modal-title">{modal.title}</h3>
                <button
                  className="v2-modal-close"
                  onClick={() => closeModal(modal.id)}
                >
                  ×
                </button>
              </div>

              {/* Content */}
              <div className="v2-modal-content">
                {typeof modal.content === 'string' ? (
                  <div dangerouslySetInnerHTML={{ __html: modal.content }} />
                ) : (
                  modal.content
                )}
              </div>

              {/* Footer */}
              <div className="v2-modal-footer">
                {modal.cancelText && (
                  <button
                    className="v2-modal-button v2-modal-button-secondary"
                    onClick={() => handleCancel(modal)}
                  >
                    {modal.cancelText}
                  </button>
                )}
                {modal.confirmText && (
                  <button
                    className="v2-modal-button v2-modal-button-primary"
                    onClick={() => handleConfirm(modal)}
                  >
                    {modal.confirmText}
                  </button>
                )}
              </div>
            </div>
          </div>
        )
      ))}
    </>
  );
};

export default ModalManager;
